import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getSubFundSummary } from '../sub-fund-setup.routes';
import { SubFundSummaryData } from '../types';

export function useGetSubFundSummary(
  fundId: string | undefined,
  options?: Omit<
    UseQueryOptions<
      SubFundSummaryData | null,
      AxiosError<unknown>,
      SubFundSummaryData | null
    >,
    'queryKey' | 'queryFn'
  >,
) {
  return useQuery({
    queryKey: ['sub-fund-summary', fundId],
    queryFn: () => getSubFundSummary(fundId!),
    enabled: !!fundId,
    ...options,
  });
}
